export default {
  title: '{{company}} updated your pickup time',
  new_time_label: 'New time',
};
